import { Component, OnInit } from '@angular/core';
import { IconService } from '@ant-design/icons-angular';
import {
  FilePdfOutline,
  FileTextOutline,
} from '@ant-design/icons-angular/icons';
import { CheckboxControl } from '../../models/controls/checkbox-control';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';
import { TranslationsService } from '../../services/translations/translations.service';
import { ShortMessageSystemRouteName } from '../../models/constants';

interface LemaniaProcess {
  document: string;
  process: string;
}

const LemaniaProcessUrl = '/api/v1/lemania/process/init';
const openingFormUrl = '/api/v1/order/readOpeningForm/';

@Component({
  selector: 'app-repatriate',
  templateUrl: './repatriate.component.html',
  styleUrls: ['./repatriate.component.scss'],
})
export class RepatriateComponent implements OnInit {
  contractUrl = '';

  termsUrl = '';

  readonly acceptTheProcess = new CheckboxControl(
    'terms',
    'acceptTermsManagement'
  );

  readonly acceptTerms = new CheckboxControl('sign', 'acceptRepatriate');

  private lemaniaProcess?: LemaniaProcess;

  private language = '';

  constructor(
    private readonly iconService: IconService,
    private readonly httpClient: HttpClient,
    private readonly userService: UserService,
    private readonly translationsService: TranslationsService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const params = new HttpParams({
      fromObject: {
        order_id: this.userService.getLastOrder().id,
        token: this.userService.getToken(),
      } as any,
    });
    this.httpClient
      .get<LemaniaProcess>(`${this.translationsService.getTranslations().api_url}${LemaniaProcessUrl}`, { params })
      .subscribe((lemaniaProcess: LemaniaProcess) => {
        this.lemaniaProcess = lemaniaProcess;
        this.userService.setProcessId(lemaniaProcess.process);
      });
    this.language = this.translationsService.getCurrentLanguage();
    this.iconService.addIcon(FilePdfOutline);
    this.contractUrl = `${this.translationsService.getTranslations().api_url}${openingFormUrl}${
      this.userService.getLastOrder().token
    }/${this.userService.getToken()}`;
    this.termsUrl = `${this.language}/terms`;
  }

  next(): void {
    this.router.navigate([this.language, ShortMessageSystemRouteName]);
  }
}
